import {
  type OfferPriceV1,
  type PimProductV11,
} from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../../global-config'
import { TENANTS_WITH_MARKETPLACE_FUNCTIONALITY } from '../../../../../marketplace'
import { productAccessorGetBestPriceOffer } from '../../../../model/productAccessor/productAccessorGetBestPriceOffer'
import { productAccessorVariantHasMultipleOffers } from '../../../../model/productAccessor/productAccessorVariantHasMultipleOffers'
import { useProductPageContext } from '../../../productPageContext'

type OfferPriceBoxProps = {
  bestPriceFlaggedOfferPrice?: OfferPriceV1
  shouldRenderSelectionBox: boolean
}

const getBestPriceFlaggedOfferPrice = (
  currentVariant: PimProductV11,
): OfferPriceV1 | undefined => {
  const { offers } = currentVariant

  return productAccessorGetBestPriceOffer({ offers })?.offerPrice
}

const shouldRenderSellerSelectionBox = ({
  currentVariant,
  isMarketplace,
}: {
  currentVariant: PimProductV11
  isMarketplace: boolean
}): boolean => {
  if (!isMarketplace || !getBestPriceFlaggedOfferPrice(currentVariant)) {
    return false
  }

  return productAccessorVariantHasMultipleOffers(currentVariant)
}

export const useProductSellerSelectionBoxData = (): OfferPriceBoxProps => {
  const { tenant } = useGlobalConfigContext()
  const { currentVariant } = useProductPageContext()

  const isMarketplace = TENANTS_WITH_MARKETPLACE_FUNCTIONALITY.has(tenant)
  const bestPriceFlaggedOfferPrice =
    getBestPriceFlaggedOfferPrice(currentVariant)

  return {
    bestPriceFlaggedOfferPrice,
    shouldRenderSelectionBox: shouldRenderSellerSelectionBox({
      currentVariant,
      isMarketplace,
    }),
  }
}
